// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#voice-bot-container {
  /* min-height: 85vh; */
  display: flex;
  justify-content: space-evenly;
  /* align-items: center; */
  margin-top: 20px;
}

#voice-bot-header {
  min-height: 15vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

#voice-bot-main-container {
  position: relative;
  z-index: 1; /* Ensure it's above the canvas */
  min-height: 100vh;
  overflow-y: auto;
}

@keyframes pulseAnimation {
  0% {
    transform: scale(1);
    box-shadow: 0 0 20px 0px rgba(0, 176, 255, 0.7);
  }

  70% {
    transform: scale(1.05);
    box-shadow: 0 0 20px 20px rgba(0, 176, 255, 0.3);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 20px 20px rgba(0, 176, 255, 0);
  }
}

@keyframes backgroundAnimation {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.call-button {
  animation: pulseAnimation 2s infinite;
}

#download-button,
#email-button {
  background-color: #1c1c1c;
  color: #fff;
  border-radius: 8px;
  padding: 8px 16px;
  text-transform: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

#download-button:hover,
#email-button:hover {
  background-color: #333;
}

@media (max-width: 768px) {
  #voice-bot-content {
    flex-direction: column;
    align-items: center;
  }

  .call-button {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.start-call-button {
  animation: pulseAnimation 2s infinite;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 200px;
  height: 200px; */
  border-radius: 50%;
  background-color: rgba(0, 176, 255, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  cursor: pointer;
  box-shadow: 0 0 30px 10px rgba(0, 176, 255, 0.2);
  transition: all 0.3s ease-in-out;
}

.start-call-button:hover {
  background-color: rgba(0, 176, 255, 0.2);
  box-shadow: 0 0 40px 15px rgba(0, 176, 255, 0.3);
}

.start-call-text {
  font-size: 24px;
  font-weight: bold;
  color: #00b0ff;
}

.upload-pdf-container {
  margin-top: 30px;
  width: 100%;
  max-width: 400px;
}

/* BACKGROUND */

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
}

body {
  overflow-y: auto;
}

#root {
  height: 100%;
  position: relative;
  z-index: 1;
}

canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 800px;
  z-index: 0; /* Ensure it's behind everything */
}

/* Remove or comment out the previous #bg styles */

/* Header */
.large-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #333;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
  background-image: url('https://www.marcoguglie.it/Codepen/AnimatedHeaderBg/demo-1/img/demo-1-bg.jpg');
  z-index: -1;
}

#demo-canvas {
  width: 100%;
  height: 100%;
}

#voice-bot-main-container {
  position: relative;
  z-index: 1;
  /* background-color: rgba(0, 0, 0, 0.5); Add a semi-transparent overlay */
}

/* ... rest of your existing styles */
`, "",{"version":3,"sources":["webpack://./src/styles/BotPage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,iCAAiC;EAC7C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,+CAA+C;EACjD;;EAEA;IACE,sBAAsB;IACtB,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;IACnB,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;kBACgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;EAC3B,eAAe;EACf,gDAAgD;EAChD,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,UAAU,EAAE,kCAAkC;AAChD;;AAEA,kDAAkD;;AAElD,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,qGAAqG;EACrG,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yEAAyE;AAC3E;;AAEA,qCAAqC","sourcesContent":["#voice-bot-container {\n  /* min-height: 85vh; */\n  display: flex;\n  justify-content: space-evenly;\n  /* align-items: center; */\n  margin-top: 20px;\n}\n\n#voice-bot-header {\n  min-height: 15vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n#voice-bot-main-container {\n  position: relative;\n  z-index: 1; /* Ensure it's above the canvas */\n  min-height: 100vh;\n  overflow-y: auto;\n}\n\n@keyframes pulseAnimation {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 20px 0px rgba(0, 176, 255, 0.7);\n  }\n\n  70% {\n    transform: scale(1.05);\n    box-shadow: 0 0 20px 20px rgba(0, 176, 255, 0.3);\n  }\n\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 20px 20px rgba(0, 176, 255, 0);\n  }\n}\n\n@keyframes backgroundAnimation {\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.call-button {\n  animation: pulseAnimation 2s infinite;\n}\n\n#download-button,\n#email-button {\n  background-color: #1c1c1c;\n  color: #fff;\n  border-radius: 8px;\n  padding: 8px 16px;\n  text-transform: none;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n#download-button:hover,\n#email-button:hover {\n  background-color: #333;\n}\n\n@media (max-width: 768px) {\n  #voice-bot-content {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .call-button {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n}\n\n.start-call-button {\n  animation: pulseAnimation 2s infinite;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* width: 200px;\n  height: 200px; */\n  border-radius: 50%;\n  background-color: rgba(0, 176, 255, 0.1);\n  backdrop-filter: blur(10px);\n  cursor: pointer;\n  box-shadow: 0 0 30px 10px rgba(0, 176, 255, 0.2);\n  transition: all 0.3s ease-in-out;\n}\n\n.start-call-button:hover {\n  background-color: rgba(0, 176, 255, 0.2);\n  box-shadow: 0 0 40px 15px rgba(0, 176, 255, 0.3);\n}\n\n.start-call-text {\n  font-size: 24px;\n  font-weight: bold;\n  color: #00b0ff;\n}\n\n.upload-pdf-container {\n  margin-top: 30px;\n  width: 100%;\n  max-width: 400px;\n}\n\n/* BACKGROUND */\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow-x: hidden;\n}\n\nbody {\n  overflow-y: auto;\n}\n\n#root {\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n\ncanvas {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 800px;\n  z-index: 0; /* Ensure it's behind everything */\n}\n\n/* Remove or comment out the previous #bg styles */\n\n/* Header */\n.large-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #333;\n  overflow: hidden;\n  background-size: cover;\n  background-position: center center;\n  background-image: url('https://www.marcoguglie.it/Codepen/AnimatedHeaderBg/demo-1/img/demo-1-bg.jpg');\n  z-index: -1;\n}\n\n#demo-canvas {\n  width: 100%;\n  height: 100%;\n}\n\n#voice-bot-main-container {\n  position: relative;\n  z-index: 1;\n  /* background-color: rgba(0, 0, 0, 0.5); Add a semi-transparent overlay */\n}\n\n/* ... rest of your existing styles */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
